enum BestExtDisplayMode {
    Name = "name",
    Icon = "icon",
    NameAndIcon = "nameAndIcon"
}
export default BestExtDisplayMode;